import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ProgressBarMode} from '@angular/material/progress-bar';
import {Observable} from 'rxjs';
import {ValidationWorkerOutputProgress} from '../../../analysis/analysis-shared/data-verification/validation-worker-data';

@Component({
  selector: 'app-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrl: './progress-dialog.component.scss',
  standalone: false
})
export class ProgressDialogComponent implements OnInit {
  public progressPercent;
  public index;
  public total;
  public mode: ProgressBarMode = 'query';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public progress: Observable<ValidationWorkerOutputProgress>
  ) {}

  ngOnInit(): void {
    this.progress.subscribe({
      next: progress => {
        this.progressPercent = progress.progressPercent;
        this.index = progress.index;
        this.total = progress.total;
        if (this.progressPercent === 100 || this.progressPercent === 0) {
          this.mode = 'query';
        } else {
          this.mode = 'determinate';
        }
      }
    });
  }
}
